import { ClientCache } from "./cache.js";
class Experimental_BaseClient {
  constructor({ network }) {
    this.cache = new ClientCache();
    this.network = network;
  }
  $extend(...registrations) {
    return Object.create(
      this,
      Object.fromEntries(
        registrations.map((registration) => {
          if ("experimental_asClientExtension" in registration) {
            const { name, register } = registration.experimental_asClientExtension();
            return [name, { value: register(this) }];
          }
          return [registration.name, { value: registration.register(this) }];
        })
      )
    );
  }
}
export {
  Experimental_BaseClient
};
//# sourceMappingURL=client.js.map
